(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderExcursion',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		var form_data,
			component_index;

		if ($('#fitbuilderexcursion-adding').val() === '1') {
			if (!Adzuki.Form.hasError(response)) {
				if ($('#fit-builder-component-index')) {
					component_index = $('#fit-builder-component-index').val();
				}

				form_data = $('#fit-builder-excursion').serialize();

				$('#saved_details_' + component_index).val(form_data);
				$('#fit-builder-details-type-message-' + component_index).removeClass('hidden');

				$('.modal').modal('hide');
			}
		} else {
			 // eslint-disable-next-line no-lonely-if
			if (!Adzuki.Form.hasError(response)) {
				window.location.href = response['data'];
				return true;
			}
		}
	};
}(jQuery, window.Adzuki || {}));